import Vue from 'vue/dist/vue.esm'
import template from './sessions_per_learner_by_school_report_template.slim'
import { getUrlWithSlug, seriesDataBar, mergeCountsBar } from '../commonChartFunctions';
import chartFilterable from '../../mixins/chart_filterable';
import barChartRange from '../../mixins/bar_chart_range';

function yAxisOptions(hasValue) {
  return {
    title: {
      text: "Sessions per Learner",
      style: { color: '#949494' }
    },
    forceNiceScale: true,
    min: hasValue ? undefined : 0,
    max: hasValue ? undefined : 1,
    labels: {
      formatter: function (value) {
        return value.toFixed(2);
      }
    }
  };
}

Vue.component('sessions_per_learner_by_school_report', {
  mixins: [template, chartFilterable, barChartRange],
  props: ['school_year_label', 'year_info', 'report_date', 'section'],
  data() {
    return {
      chartData: {},
      series: [{
        name: 'sessions',
        data: []
      }],
      chartOptions: {
        dataLabels: {
          enabled: false
        },
        chart: {
          type: 'bar',
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const schoolName = config.w.config.series[0].data[config.dataPointIndex].x;
              const urlWithSlug = getUrlWithSlug(this.year_info.current_schools_year, schoolName);
              const redirectUrl = urlWithSlug + "/frequency_reports";
              window.open(redirectUrl, '_blank');
            }
          }
        },
        yaxis: yAxisOptions(true),
        xaxis: {
          labels: {
            trim: true,
            rotate: -55,
          }
        },
        grid: {
          row: {
            colors: ['#FFFFFF', '#F3F3F3']
          },
          padding: {
            left: 50,
            bottom: 30
          },
        }
      }
    }
  },
  methods: {
    updateChart: function() {
      const data = seriesDataBar(mergeCountsBar(this.chartData, this.startDate, this.endDate));
      const hasValue = data.some(point => Number(point.y) > 0);

      const yaxis = yAxisOptions(hasValue);

      this.chartOptions.yaxis = yaxis;
      this.$refs.perSchoolApexChart?.updateOptions({ yaxis }, false, false);
      this.series = [{ name: 'sessions', data }];
    }
  }
});
